import client from './client';

/**
 * Calculate the price for a property booking given check-in and check-out dates.
 * Returns: { nights, basePrice, appliedRule, nightlyRate, subtotal }
 */
export const calculatePrice = async (propertyId, checkIn, checkOut) => {
  const { data } = await client.get(`/api/public/properties/${propertyId}/calculate-price`, {
    params: { checkIn, checkOut },
  });
  return data;
};

/**
 * Get enabled payment gateways (public keys only)
 * Returns: { paystack: { publicKey, mode, enabled }, moments: { publicKey, mode, enabled } }
 */
export const getPaymentGateways = async () => {
  // Payment gateways endpoint is public (only public keys + enabled status are returned)
  const { data } = await client.get('/api/settings/payment-gateways');
  return data;
};
